/**
 * Which agent runs / tasks the signed-in user may LIST (#5917).
 *
 * firestore.rules gates agent_runs and agent_tasks by configId for the finance, HR, recruiting and safety
 * agents (every run and task carries configId; plan-card tasks carry no module, so module cannot gate). A rules-checked list must PROVE the user may read every doc it can return, so a
 * list that is not pinned to one agent has to exclude, with `not-in`, exactly the gated agents the user
 * lacks. Keep this table in step with `agentConfigReadable` in firestore.rules.
 */
import type { ModuleId } from '../modules/types';

/** configId of each module-gated agent -> the module that owns it. */
export const MODULE_GATED_AGENT_CONFIGS: Readonly<Record<string, ModuleId>> = {
  'finance-agent': 'P4',
  'hr-agent': 'P9',
  'recruiting-agent': 'P14',
  'recruiting-agent-scheduled': 'P14',
  'safety-agent': 'P17',
};

/** configIds the user must NOT see, for `where('configId', 'not-in', ...)`. Empty = may see all. */
export function blockedAgentConfigIds(hasModuleAccess: (id: ModuleId) => boolean): string[] {
  return Object.entries(MODULE_GATED_AGENT_CONFIGS)
    .filter(([, moduleId]) => !hasModuleAccess(moduleId))
    .map(([configId]) => configId);
}
